"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tagPickerButtonClassNames: function() {
        return tagPickerButtonClassNames;
    },
    useTagPickerButtonStyles_unstable: function() {
        return useTagPickerButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tagPickerButtonClassNames = {
    root: 'fui-TagPickerButton'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    button: {
        Bt984gj: "f122n59",
        sshi5w: "f1nxs5xn",
        De3pzq: "f1c21dwh",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh",
        B7ck84d: "f1ewtqcl",
        sj55zd: "f19n0e5",
        i8kkvl: "f14mj54c",
        Bceei9c: "f1k6fduh",
        Bahqtrf: "fk6fouc",
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        Bh6795r: "fqerorx",
        Brovlpu: "ftqa4ok"
    },
    placeholder: {
        sj55zd: "fxc4j92"
    },
    medium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "fye6m5k",
            "f3cq2dl"
        ]
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f14ev680",
            "f58uxzw"
        ]
    },
    "extra-large": {
        i8kkvl: "f1rjii52",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f139mn7i",
            "f1v3q0m"
        ]
    },
    outline: {
        De3pzq: "fxugw4r",
        Bgfg5da: 0,
        B9xav0g: "f1c1zstj",
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fhz96rm"
    },
    outlineInteractive: {
        Bgoe8wy: "fvcxoqz",
        Bwzppfd: [
            "f1ub3y4t",
            "f1m52nbi"
        ],
        oetu4i: "flmw63s",
        gg5e9n: [
            "f1m52nbi",
            "f1ub3y4t"
        ],
        B6oc9vd: "fvs00aa",
        ak43y8: [
            "f1assf6x",
            "f4ruux4"
        ],
        wmxk5l: "fqhmt4z",
        B50zh58: [
            "f4ruux4",
            "f1assf6x"
        ]
    },
    underline: {
        De3pzq: "f1c21dwh",
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        Bgfg5da: "f9ez7ne",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "fokr779"
    },
    "filled-lighter": {
        De3pzq: "fxugw4r",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fs2rfia"
    },
    "filled-darker": {
        De3pzq: "f16xq7d1",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fs2rfia"
    },
    invalid: {
        tvckwq: "fs4k3qj",
        gk2u95: [
            "fcee079",
            "fmyw78r"
        ],
        hhx65j: "f1fgmyf4",
        Bxowmz0: [
            "fmyw78r",
            "fcee079"
        ]
    },
    invalidUnderline: {
        hhx65j: "f1fgmyf4"
    },
    disabled: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1c21dwh",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        Bjwas2f: "fg455y9",
        Bn1d65q: [
            "f1rvyvqg",
            "f14g86mu"
        ],
        Bxeuatn: "f1cwzwz",
        n51gp8: [
            "f14g86mu",
            "f1rvyvqg"
        ]
    },
    disabledText: {
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr"
    },
    hidden: {
        mc9l5x: "fjseox"
    },
    visuallyHidden: {
        Bh84pgu: "f1ekcaio",
        Bqenvij: "f1mpe4l3",
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1jlpb2r",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1c5fvqg",
        a9b677: "frkrog8",
        qhf8xq: "f1euv43f"
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f1nxs5xn{min-height:32px;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f14mj54c{column-gap:var(--spacingHorizontalXXS);}",
        ".f1k6fduh{cursor:pointer;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".fqerorx{flex-grow:1;}",
        ".fxc4j92{color:var(--colorNeutralForeground4);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        [
            ".fye6m5k{padding:3px var(--spacingHorizontalSNudge) 3px calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS));}",
            {
                p: -1
            }
        ],
        [
            ".f3cq2dl{padding:3px calc(var(--spacingHorizontalSNudge) + var(--spacingHorizontalXXS)) 3px var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".f14ev680{padding:5px var(--spacingHorizontalMNudge) 5px calc(var(--spacingHorizontalMNudge) + var(--spacingHorizontalXXS));}",
            {
                p: -1
            }
        ],
        [
            ".f58uxzw{padding:5px calc(var(--spacingHorizontalMNudge) + var(--spacingHorizontalXXS)) 5px var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        ".f1rjii52{column-gap:var(--spacingHorizontalSNudge);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        [
            ".f139mn7i{padding:7px var(--spacingHorizontalM) 7px calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge));}",
            {
                p: -1
            }
        ],
        [
            ".f1v3q0m{padding:7px calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge)) 7px var(--spacingHorizontalM);}",
            {
                p: -1
            }
        ],
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        [
            ".fhz96rm{border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);}",
            {
                p: -2
            }
        ],
        ".f1c1zstj{border-bottom-color:var(--colorNeutralStrokeAccessible);}",
        [
            ".f9ez7ne{border-bottom:var(--strokeWidthThin) solid var(--colorNeutralStrokeAccessible);}",
            {
                p: -1
            }
        ],
        [
            ".fokr779{border-radius:0;}",
            {
                p: -1
            }
        ],
        [
            ".fs2rfia{border:var(--strokeWidthThin) solid transparent;}",
            {
                p: -2
            }
        ],
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        [
            ".fs2rfia{border:var(--strokeWidthThin) solid transparent;}",
            {
                p: -2
            }
        ],
        ".fs4k3qj:not(:focus-within),.fs4k3qj:hover:not(:focus-within){border-top-color:var(--colorPaletteRedBorder2);}",
        ".fcee079:not(:focus-within),.fcee079:hover:not(:focus-within){border-right-color:var(--colorPaletteRedBorder2);}",
        ".fmyw78r:not(:focus-within),.fmyw78r:hover:not(:focus-within){border-left-color:var(--colorPaletteRedBorder2);}",
        ".f1fgmyf4:not(:focus-within),.f1fgmyf4:hover:not(:focus-within){border-bottom-color:var(--colorPaletteRedBorder2);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fjseox{display:none;}",
        ".f1ekcaio{clip:rect(0px, 0px, 0px, 0px);}",
        ".f1mpe4l3{height:1px;}",
        [
            ".f1jlpb2r{margin:-1px;}",
            {
                p: -1
            }
        ],
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        [
            ".f1c5fvqg{padding:0px;}",
            {
                p: -1
            }
        ],
        ".frkrog8{width:1px;}",
        ".f1euv43f{position:absolute;}"
    ],
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    h: [
        ".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".flmw63s:hover{border-bottom-color:var(--colorNeutralStrokeAccessible);}"
    ],
    a: [
        ".fvs00aa:active{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f1assf6x:active{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f4ruux4:active{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".fqhmt4z:active{border-bottom-color:var(--colorNeutralStrokeAccessible);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useTagPickerButtonStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(tagPickerButtonClassNames.root, styles.button, styles[state.size], state.hasSelectedOption && styles.visuallyHidden, state.root.className);
    return state;
};
